import { apiMutate } from '../csrf-fetch';
import { lerErroApi } from '../vendas/erro-api';

/** Usa o contrato existente e preserva uma mensagem recuperável em falhas de rede. */
export async function reativarFornecedor(id: string): Promise<string | null> {
  try {
    const resposta = await apiMutate(`/api/v1/compras/fornecedores/${encodeURIComponent(id)}/reativar`, {});
    if (resposta.ok) return null;
    return (await lerErroApi(resposta, 'Não foi possível reativar o fornecedor.')).mensagem;
  } catch {
    return 'Não foi possível reativar o fornecedor. Verifique a conexão e tente novamente.';
  }
}
